"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiveProgressPercentageBasedOnCurrentTime = exports.getDVRWindowLocationInProgramWindow = exports.getLiveProgressFromPercentage = exports.getLiveProgressFromPercentageWithinProgramWindow = exports.getLiveProgressFromPercentageWithinDVRWindow = exports.getLiveDateStringFromPercentage = exports.getLiveDateStringFromPercentageWithinProgramWindow = exports.getLiveDateStringFromPercentageWithinDVRWindow = exports.areProgramMetadataValid = void 0;
var PERCENT = 100;
function areProgramMetadataValid(programStart, programEnd) {
    return Boolean(programStart && programEnd && programStart < programEnd);
}
exports.areProgramMetadataValid = areProgramMetadataValid;
function getLiveDateStringFromPercentageWithinDVRWindow(dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate) {
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    var dvrWindowLength = dvrWindowEnd - dvrWindowStart;
    var positionWithinDVRWindow = dvrWindowLength * progress;
    var toEnd = dvrWindowLength - positionWithinDVRWindow;
    return dvrWindowEndDate - toEnd;
}
exports.getLiveDateStringFromPercentageWithinDVRWindow = getLiveDateStringFromPercentageWithinDVRWindow;
function getLiveDateStringFromPercentageWithinProgramWindow(programStart, programEnd, progress) {
    var programWindowLength = programEnd - programStart;
    var positionWithinProgramWindow = programWindowLength * progress;
    var toEnd = programWindowLength - positionWithinProgramWindow;
    return programEnd - toEnd;
}
exports.getLiveDateStringFromPercentageWithinProgramWindow = getLiveDateStringFromPercentageWithinProgramWindow;
function getLiveDateStringFromPercentage(programStart, programEnd, dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate) {
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    return areProgramMetadataValid(programStart, programEnd)
        ? getLiveDateStringFromPercentageWithinProgramWindow(programStart, programEnd, progress)
        : getLiveDateStringFromPercentageWithinDVRWindow(dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate);
}
exports.getLiveDateStringFromPercentage = getLiveDateStringFromPercentage;
function getLiveProgressFromPercentageWithinDVRWindow(dvrWindowStart, dvrWindowEnd, progress) {
    var dvrWindowLength = dvrWindowEnd - dvrWindowStart;
    var positionWithinDVRWindow = dvrWindowLength * progress;
    return dvrWindowStart + positionWithinDVRWindow;
}
exports.getLiveProgressFromPercentageWithinDVRWindow = getLiveProgressFromPercentageWithinDVRWindow;
function getLiveProgressFromPercentageWithinProgramWindow(programStart, programEnd, dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate) {
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    var dvrWindowLength = dvrWindowEnd - dvrWindowStart;
    var mappedProgramWindowInPlayerTimeUnits = {
        start: dvrWindowStart -
            (dvrWindowEndDate - dvrWindowLength - programStart),
        end: programEnd - dvrWindowEndDate + dvrWindowEnd,
    };
    var mappedProgramWindowLength = mappedProgramWindowInPlayerTimeUnits.end -
        mappedProgramWindowInPlayerTimeUnits.start;
    return (mappedProgramWindowInPlayerTimeUnits.start +
        mappedProgramWindowLength * progress);
}
exports.getLiveProgressFromPercentageWithinProgramWindow = getLiveProgressFromPercentageWithinProgramWindow;
function getLiveProgressFromPercentage(programStart, programEnd, dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate) {
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    return areProgramMetadataValid(programStart, programEnd)
        ? getLiveProgressFromPercentageWithinProgramWindow(programStart, programEnd, dvrWindowStart, dvrWindowEnd, progress, dvrWindowEndDate)
        : getLiveProgressFromPercentageWithinDVRWindow(dvrWindowStart, dvrWindowEnd, progress);
}
exports.getLiveProgressFromPercentage = getLiveProgressFromPercentage;
function getDVRWindowLocationInProgramWindow(isLive, programStart, programEnd, dvrWindowStart, dvrWindowEnd, dvrWindowEndDate) {
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    if (!isLive || !areProgramMetadataValid(programStart, programEnd))
        return {
            start: 0,
            end: PERCENT,
        };
    var dvrWindowLength = dvrWindowEnd - dvrWindowStart;
    var mappedProgramWindowInPlayerTimeUnits = {
        start: dvrWindowStart -
            (dvrWindowEndDate - dvrWindowLength - programStart),
        end: programEnd - dvrWindowEndDate + dvrWindowEnd,
    };
    var mappedProgramWindowInPlayerTimeUnitsLength = mappedProgramWindowInPlayerTimeUnits.end -
        mappedProgramWindowInPlayerTimeUnits.start;
    return {
        start: Math.max(0, ((dvrWindowStart - mappedProgramWindowInPlayerTimeUnits.start) /
            mappedProgramWindowInPlayerTimeUnitsLength) *
            PERCENT),
        end: Math.min(PERCENT, ((dvrWindowEnd - mappedProgramWindowInPlayerTimeUnits.start) /
            mappedProgramWindowInPlayerTimeUnitsLength) *
            PERCENT),
    };
}
exports.getDVRWindowLocationInProgramWindow = getDVRWindowLocationInProgramWindow;
function getLiveProgressPercentageBasedOnCurrentTime(programStart, programEnd, dvrWindowStart, dvrWindowEnd, playerCurrentTime, playerRelativeSeekTime, dvrWindowEndDate) {
    if (playerRelativeSeekTime === void 0) { playerRelativeSeekTime = 0; }
    if (dvrWindowEndDate === void 0) { dvrWindowEndDate = Date.now(); }
    var programMetadataAreValid = areProgramMetadataValid(programStart, programEnd);
    var _a = {
        start: programMetadataAreValid ? programStart : dvrWindowStart,
        end: programMetadataAreValid ? programEnd : dvrWindowEnd,
    }, start = _a.start, end = _a.end;
    var windowRelativeTime = programMetadataAreValid
        ? dvrWindowEndDate - (dvrWindowEnd - playerCurrentTime)
        : playerCurrentTime;
    return ((windowRelativeTime + playerRelativeSeekTime - start) / (end - start));
}
exports.getLiveProgressPercentageBasedOnCurrentTime = getLiveProgressPercentageBasedOnCurrentTime;
//# sourceMappingURL=index.js.map